import React, { useEffect } from 'react';
import ResetCode from '../../components/ResetPassword/ResetCode/ResetCode';
import HeaderAuth from '../../components/HeaderAuth/HeaderAuth';

const ResetCodePage = () => {
	useEffect(() => {
		document.body.removeAttribute('class');
		document.title = 'Відновлення пароля | New Brain';
	}, []);
	return (
		<div>
			<HeaderAuth />
			<section className='container container--login'>
				<ResetCode />
			</section>
		</div>
	);
};

export default ResetCodePage;